import { render } from "./bimeh.vue?vue&type=template&id=95a8ec76"
import script from "./bimeh.vue?vue&type=script&lang=js"
export * from "./bimeh.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/clinicyas-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__